import { TypographyVariant } from "../../../constants/typography";
import { Dialog } from "../../core/Dialog/Dialog";
import { Typography } from "../../core/Typography/Typography";
import { useStyles } from "./ShopPopup.style";
import { useTranslation } from "react-i18next";
import { StaticImage } from "../../core/StaticImage/StaticImage";
import FlipKart1x from "../../../assets/icons/flipkart1x.webp";
import FlipKart2x from "../../../assets/icons/flipkart2x.webp";
import FlipKart3x from "../../../assets/icons/flipkart3x.webp";
import PoorVika1x from "../../../assets/icons/poorvika1x.webp";
import PoorVika2x from "../../../assets/icons/poorvika2x.webp";
import PoorVika3x from "../../../assets/icons/poorvika3x.webp";
import { FLIPKART_URL, POORVIKA_URL } from "../../../constants/paywall";
import Button from "../../core/Button/Button";

type TShopPopup = {
  isShopPopupOpen: boolean;
  setIsShopPopupOpen: (isShopPopupOpen: boolean) => void;
};

const ShopPopup: React.FC<TShopPopup> = (props) => {
  const { isShopPopupOpen, setIsShopPopupOpen } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const handlePoorVikaClick = () => {
    window.open(POORVIKA_URL, "_blank", "noopener,noreferrer");
    setIsShopPopupOpen(false);
  };

  const handleFlipkartClick = () => {
    window.open(FLIPKART_URL, "_blank", "noopener,noreferrer");
    setIsShopPopupOpen(false);
  };

  return (
    <Dialog open={isShopPopupOpen} onClose={() => setIsShopPopupOpen(false)}>
      <div className={classes.dialogContent}>
        <Typography
          variant={TypographyVariant.HeadingH3Bold}
          className={classes.title}
        >
          {t("ShopPopup_Choose Your Retailer")}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB3Medium}
          className={classes.description}
        >
          {t(
            "ShopPopup_Shop for the ONMO+ Smart Console Bundle on these recommended retailer websites.",
          )}
        </Typography>

        <div className={classes.retailerSection}>
          <Button
            className={classes.retailerButton}
            onClick={handlePoorVikaClick}
            data-selected-class={classes.selected}
            data-gamepad="shop-poorvika"
          >
            <StaticImage
              src={PoorVika1x}
              src2x={PoorVika2x}
              src3x={PoorVika3x}
              alt="Poorvika"
            />
          </Button>
          <Button
            className={classes.retailerButton}
            onClick={handleFlipkartClick}
            data-selected-class={classes.selected}
            data-gamepad="shop-flipkart"
          >
            <StaticImage
              src={FlipKart1x}
              src2x={FlipKart2x}
              src3x={FlipKart3x}
              alt="Flipkart"
            />
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ShopPopup;
